export default __webpack_public_path__ + "static/media/next.51b6acef.wav";